var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, makeObservable } from 'mobx';
export class ActorEvents {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get actor() {
        return this.parent;
    }
    fireEvent(rawEvent) {
        try {
            const event = this.actor.core.aspectEvents.eventCreation.createFromRawEvent(rawEvent);
            this.actor.actorAspects.allAspectsArray.forEach(aspect => aspect.aspectEvents.eventReception.handleEvent(event));
        }
        catch (e) {
            console.log(e);
        }
    }
}
__decorate([
    action.bound
], ActorEvents.prototype, "fireEvent", null);
